import {customerType, segment} from './helpers'

export const checkoutSubmitClicked = (orderId, isPhone) =>
  segment('Clicked Checkout Submit', {
    mobile: isPhone,
    orderId,
  })

export const checkoutIframeError = (errorCode, errorDescription) =>
  segment('Checkout iframe Error', {
    errorCode,
    errorDescription,
  })

export const checkoutStarted = ({isOwner, eventType, eventId, mobile, daysToEvent, orderTypes}) =>
  segment('Checkout Started', {
    customerType: customerType(isOwner),
    eventType,
    eventId,
    mobile,
    daysToEvent,
    orderTypes,
  })

export const shippingAddressAutocompleted = () => segment('Shipping Address Autocompleted')

export const checkoutSubmittedShippingInfo = (hadError) =>
  segment('Checkout Submitted Shipping Info', {hadError})

export const checkoutSubmittedPaymentInfo = ({isChargingCardOnFile}) =>
  segment('Checkout Submitted Payment Info', {useCardOnFile: isChargingCardOnFile})

export const checkoutFitGuaranteeModalClicked = (text) =>
  segment('Clicked Modal Primary CTA', {text})

export const viewedCheckoutReviewPage = (discount, insurance, shipping, subtotal, tax) =>
  segment('Viewed Checkout Review Page', {
    discount,
    insurance,
    shipping,
    subtotal,
    tax,
  })
